// Full content copied from https://zhelta.com/systems
// Keep this file as the single source of truth for the Systems page.

export const SYSTEMS_HERO = {
  eyebrow: 'Built on more than a decade of practice',
  titleA: 'Enterprise IT Solutions.',
  titleB: 'Simplified.',
  body:
    'Professional IT management and cybersecurity protection that keeps your business running smoothly, securely, and efficiently.',
  primaryCTA: { label: 'Schedule Consultation', href: '/systems/book-demo' },
  secondaryCTA: { label: 'View Solutions', href: '/systems/solutions' },
};

export const SYSTEMS_STATS = [
  { value: '12+',     label: 'Years in practice' },
  { value: 'Jul 2024', label: 'Full operations launch' },
  { value: '3',       label: 'Integrated divisions' },
  { value: '12',      label: 'IT solutions catalogued' },
];

export const SYSTEMS_WHY = {
  eyebrow: 'Why Zhelta Systems',
  title: 'Built for modern businesses',
  subtitle:
    'Technology infrastructure that delivers security, reliability, and peace of mind.',
  items: [
    {
      icon: 'ShieldCheck',
      title: 'Enterprise-Grade Security',
      body:
        'Military-grade encryption and advanced threat protection for all your systems and data.',
    },
    {
      icon: 'Zap',
      title: 'Lightning-Fast Response',
      body:
        'Average response time under 15 minutes with dedicated support teams available 24/7.',
    },
    {
      icon: 'TrendingUp',
      title: 'Scalable Solutions',
      body:
        'Infrastructure that grows with your business, from startups to enterprise organizations.',
    },
    {
      icon: 'Award',
      title: 'Certified Experts',
      body:
        'Team of certified professionals with expertise across all major technology platforms.',
    },
  ],
};

export const SYSTEMS_SOLUTIONS = {
  title: 'Comprehensive IT solutions',
  subtitle:
    'Everything you need to manage, secure, and scale your technology infrastructure.',
  items: [
    {
      badge: 'MOST POPULAR',
      title: 'Managed IT Services',
      body:
        'Complete proactive monitoring, management, and support for all your business devices and IT infrastructure.',
      cta: 'Learn more',
      icon: 'Server',
      featured: true,
    },
    {
      badge: 'INFRASTRUCTURE',
      title: 'IT Systems Management',
      body: 'Management of operating systems and device environments.',
      cta: 'Explore',
      icon: 'Cpu',
    },
    {
      badge: 'SUPPORT',
      title: 'IT Help Desk & Remote Support',
      body: 'Remote assistance and technical support.',
      cta: 'Explore',
      icon: 'Headphones',
    },
    {
      badge: 'INFRASTRUCTURE',
      title: 'Cloud & Infrastructure Support',
      body: 'Support for cloud platforms and hosted infrastructure.',
      cta: 'Explore',
      icon: 'Cloud',
    },
    {
      badge: 'SECURITY',
      title: 'Cybersecurity Support',
      body: 'Protection and monitoring for business systems.',
      cta: 'Explore',
      icon: 'Lock',
    },
    {
      badge: 'SECURITY',
      title: 'Backup & Data Protection',
      body: 'Secure data backup and recovery services.',
      cta: 'Explore',
      icon: 'HardDrive',
    },
  ],
};

export const SYSTEMS_PROCESS = {
  eyebrow: 'SIMPLE PROCESS',
  title: 'Getting started is simple',
  subtitle:
    'From consultation to ongoing support, we make IT management effortless.',
  steps: [
    {
      n: '01',
      title: 'Schedule Consultation',
      body:
        'Book a free consultation to discuss your technology needs, challenges, and goals with our expert team.',
      bullets: [
        'Free initial consultation',
        'Assess current infrastructure',
        'Custom recommendations',
      ],
      icon: 'CalendarCheck',
    },
    {
      n: '02',
      title: 'Quick Setup & Onboarding',
      body:
        'We securely configure and connect your systems with minimal disruption to your daily operations.',
      bullets: [
        'Secure system onboarding',
        'Zero disruption deployment',
        'Complete configuration',
      ],
      icon: 'Settings2',
    },
    {
      n: '03',
      title: '24/7 Ongoing Support',
      body:
        'Enjoy proactive monitoring, rapid issue resolution, and continuous optimization of your IT infrastructure.',
      bullets: [
        '24/7 monitoring & alerts',
        'Proactive maintenance',
        'Priority support access',
      ],
      icon: 'Activity',
    },
  ],
};

export const SYSTEMS_EXPERTISE = {
  title: 'Enterprise-grade technology expertise',
  subtitle:
    "We deliver expert services and support for the world's leading technology platforms.",
  platforms: [
    { name: 'Microsoft 365', desc: 'Cloud services' },
    { name: 'AWS', desc: 'Cloud infrastructure' },
    { name: 'Google Cloud', desc: 'Cloud platform' },
    { name: 'Cisco', desc: 'Networking' },
    { name: 'VMware', desc: 'Virtualization' },
    { name: 'Dell EMC', desc: 'Storage' },
  ],
  footer:
    'Experienced with Microsoft 365, AWS, Google Cloud, Cisco, VMware, Dell EMC, and more',
};

export const SYSTEMS_COMPARE = {
  title: 'ZHELTA vs. Other MSPs',
  subtitle: 'See how we deliver superior value and service',
  columns: [
    {
      highlight: true,
      brand: 'ZHELTA Systems',
      tier: 'Premium Service',
      items: [
        '24/7 proactive monitoring & support',
        'Dedicated account manager',
        'Enterprise-grade security solutions',
        'Predictable flat-rate pricing',
        'Custom IT strategy & roadmap',
        '15-minute response time guarantee',
        'Cloud migration expertise',
        'Quarterly business reviews',
      ],
      positive: true,
    },
    {
      brand: 'Traditional MSPs',
      tier: 'Standard Service',
      items: [
        'Business hours support only',
        'Shared support team',
        'Basic antivirus protection',
        'Hourly billing or unclear pricing',
        'Generic IT recommendations',
        'Slow response times',
        'Limited cloud expertise',
        'Annual reviews only',
      ],
      positive: false,
    },
    {
      brand: 'In-House IT',
      tier: 'Internal Team',
      items: [
        'Limited coverage hours',
        'Single point of knowledge',
        'Limited security expertise',
        'High salary & benefits costs',
        'Narrow skillset limitations',
        'Reactive problem-solving',
        'Requires ongoing training costs',
        'No strategic guidance',
      ],
      positive: false,
    },
  ],
};

export const SYSTEMS_FINAL_CTA = {
  eyebrow: 'Transform Your IT Infrastructure',
  title: 'Ready to modernize your technology infrastructure?',
  body:
    'Speak with our specialists and discover how ZHELTA Systems can support your devices, infrastructure, and business systems.',
  primaryCTA: { label: 'Schedule Consultation', href: '/systems/book-demo' },
  secondaryCTA: { label: 'Contact Sales', href: '/systems/contact' },
};
